import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { t } from "@/lib/i18n";

export default function VerifyEmailPage() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const { user, refreshUser } = useAuth();
  const [state, setState] = useState(token ? "verifying" : "missing");
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token) return;
    api.post("/auth/verify-email", { token })
      .then(async () => { setState("done"); if (user) await refreshUser(); })
      .catch((e) => { setState("failed"); setMessage(apiError(e)); });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const resend = async () => {
    try { await api.post("/auth/resend-verification"); setMessage(t("portal.resent")); } catch (e) { setMessage(apiError(e)); }
  };

  return (
    <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6 sm:py-16" data-testid="verify-email-page">
      <div className="max-w-md">
        <h1 className="text-4xl sm:text-5xl">{t("auth.verifyTitle")}</h1>
        {state === "verifying" && <p className="mt-6 text-ink-500" role="status">{t("auth.verifying")}</p>}
        {state === "done" && (
          <div className="mt-6 surface p-6 confirm-pop" role="status" data-testid="verify-success">
            <p className="font-serif text-xl font-semibold">{t("auth.verified")}</p>
            <Link to="/portal" className="btn-primary mt-5" data-testid="verify-go-portal">{t("auth.goToPortal")}</Link>
          </div>
        )}
        {(state === "failed" || state === "missing") && (
          <div className="mt-6 surface p-6" role="alert" data-testid="verify-failed">
            <p className="font-serif text-xl font-semibold">{t("auth.verifyFailed")}</p>
            {message && <p className="mt-2 text-ink-900">{message}</p>}
            {user ? (
              <button type="button" onClick={resend} className="btn-primary mt-5" data-testid="verify-resend">{t("auth.resend")}</button>
            ) : (
              <Link to="/sign-in" className="btn-primary mt-5">{t("auth.signIn")}</Link>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
